<template>
  <div>

    <v-data-table :headers="headers" class="elevation-1 dp" :items="subscriptions" hide-default-header
      :loading="loading" :loading-text="$t('message.loadingText', { value: 'default' })">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Alert report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="loadDialog" v-if="getterContact?.internal">
            New Item
          </v-btn>

        </v-toolbar>
      </template>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="cursor: pointer" v-for="item in headers" :key="item.value">
              {{ item.text }}
            </th>
          </tr>
        </thead>
      </template>
      <template>
        <v-icon small class="mr-2">
          mdi-pencil
        </v-icon>
        <v-icon small>
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>

      </template>
      <!--action slot -->
      <template v-slot:item.status="{ item }">
        <v-switch inset color="#EEBB07" v-model="item.status" :readonly="item.readonly" dense hide-details class="mt-0"
          @click="toggle(item)"></v-switch>
      </template>
      <!-- prepend body slot (teams)-->
      <template v-slot:body.prepend>
        <tr v-for="t in teams" :key="t.mail" class="dis">
          <td>
            Service request
          </td>
          <td>
            {{ t.mail }}
          </td>
          <td>
            by default
          </td>

        </tr>
      </template>

    </v-data-table>

    <!-- add souscription dialog -->

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Subscription</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-autocomplete :label="$t('message.selectCustomer', { value: 'default' })" dense :items="getterClient"
                item-text="name" item-value="customernum" v-model="selectedCustomer" readonly></v-autocomplete>
            </v-row>
            <v-row class="mt-8">
              <v-autocomplete label="Select notification" dense :items="notifications" item-text="name" item-value="id"
                v-model="selectedNotification"></v-autocomplete>
            </v-row>
            <v-row>
              <v-text-field v-model="email" :rules="[rules.required, rules.email]" label="E-mail"></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="save">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CoreService from "@/services/CoreService";


export default {
  data() {
    return {
      loading: true,
      selectedCustomer: "",
      selectedNotification: "",
      subscriptions: [],
      teams: [],
      dialog: false,
      notifications: [],
      email: '',
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    };
  },
  watch: {
    getterCurrentClient: function () {
      this.loadNotifications();
      this.loadSubscrition();

    },
  },
  methods: {
    ...mapActions("customer", {
      actionGetTeams: "loadTeams",
    }),


    async getTeams() {
      await this.actionGetTeams(this.getterCurrentClient);
      this.teams = this.getterTeams;
    },

    loadNotifications() {
      CoreService.findAllNotifications().then(({ data }) => {
        this.notifications = data;
      });
    },

    toggle(item) {
      CoreService.toggleSubscription(item.id).then(() => {
        this.loadSubscrition()
      });
    },

    async loadSubscrition() {
      await CoreService.findSubscriptionbyCustomer(this.getterCurrentClient).then(({ data }) => {
        this.subscriptions = data;
      });
      await this.getTeams()
      this.loading = false
    },

    loadDialog() {
      this.selectedCustomer = this.getterCurrentClient;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    save() {
      CoreService.createSubscription({
        mail: this.email,
        customer: this.selectedCustomer,
        status: true,
        notification: this.selectedNotification
      }).then(() => {
        this.loadSubscrition()
        this.close()
      });
    }
  },

  mounted() {
    this.loadNotifications();
    this.getTeams()
    this.loadSubscrition();

  },

  computed: {
    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterClient: "getClients",
      getterContact: "getUserContact",
    }),
    ...mapGetters("customer", {
      getterLocos: "getFilterLoc",
      getterTeams: "getTeams",
    }),

    headers() {
      return [
        { text: 'Notification', align: 'start', value: 'notification.name' },
        { text: 'User mail', value: 'mail' },
        { text: 'Status', value: 'status' }
      ]
    },
  },
}
</script>
<style scoped>
.dp.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  color: #fff;
  font-size: 16px;
}

.theme--light.v-icon {
  color: #fff;
}

.dp.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th:hover {
  color: #fff;
}

.dis {
  font-style: italic;
  background-color: lightgray;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}
</style>
